import React from 'react';
import { useSelector } from 'react-redux';
import BalanceItem from './index';
import { OM, TOKEN_OPTIONS } from '../../../../constants/blockchain-constants';
import { formatToken } from '../../../../helpers/token-helper';

const Om = () => {
  const { omBalance } = useSelector((state) => state.token);
  const usdPrice = useSelector((state) => state.basic.currency.USD[OM]);

  return (
    <BalanceItem
      token={TOKEN_OPTIONS[OM].title}
      icon={TOKEN_OPTIONS[OM].icon}
      balance={omBalance}
      buttonText='Stake'
      formattedBalance={formatToken(omBalance)}
      usdPrice={usdPrice}
      withoutStaking
    />
  );
};

export default Om;
